import { GET_HOST } from "./action";

const initialState = {
  data: [],
};

export const getHistory = (state = initialState, action) => {
  switch (action.type) {
    case GET_HOST:
      return {
        ...state,
        data: action.payload.data,
      };
    default:
      return state;
  }
};
